import React, { useEffect, useCallback, useState } from "react";
import styled from "styled-components";
import Title from "./title";
import ToolsBar from "./toolsBar";
import PaginationNav from "./paginationNav";
import {
  useParams,
  Switch,
  Route,
  useLocation,
  Redirect,
  useHistory,
} from "react-router-dom";
import Navbar from "./navbar";
import logger from "utils/logger";
import util from "utils/util";
import guide from "services/guide";
import PluginDetail from "./pluginDetail";
import Releases from "./releases";
import data from "services/data";
import PluginVerModal from "./modals/pluginVerModal";
import ConfirmModal from "./modals/confirmModal";
import Filter from "./filter";
import DatePicker from "./datePicker";
import Button from "./button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import notifier from "utils/notifier";
import http from "utils/http";
import { Table, Button as BTN,Drawer } from 'antd';
import moment from "moment";
import ToolGroup from "./toolGroup";

const StyledPluginVer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

const StyledMain = styled.main`
  background-color: ${({ theme }) => theme.secondBackgroundColor};
  box-shadow: ${({ theme }) => theme.boxShadow};
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 50px;
`;

const StyledSection = styled.section`
  width: 100%;
  min-height: 400px;
  word-wrap: break-word;
  text-align: justify;

  display: flex;
  flex-direction: column;
  row-gap: 10px;
`;

const StyledFilterContainer = styled.div`
  display: flex;
  column-gap: 25px;
`;

const StyledDatePickerGroup = styled.div`
  display: flex;
  column-gap: 7px;
  align-items: center;
`;

const StyledIcon = styled(FontAwesomeIcon)``;

const tablePageSize = 20;

const flagFilterItems = data.flagFilterItems;
const defaultFlagFilterItem = data.defaultFlagFilterItem;
const systemFilterItems = data.systemFilterItems;
const defaultSystemFilterItems = data.defaultSystemFilterItems;

let cancelSources = [];

const PluginVer = ({ user }) => {
  const [pluginInfo, setPluginInfo] = useState(null);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [flagFilterItem, setFlagFilterItem] = useState(defaultFlagFilterItem);
  const [systemFilterItem, setSystemFilterItem] = useState(defaultSystemFilterItems);
  const [publishDateStart, setPublishDateStart] = useState(null);
  const [publishDateEnd, setPublishDateEnd] = useState(null);
  const [list, setList] = useState([]);
  const [modalVisible, setModalVisible] = useState({
    pluginInfoModal: false,
    confirmModal: false,
  });
  const [modalType, setModalType] = useState("");
  const [confirmModalType, setConfirmModalType] = useState("pluginVer");
  const [currentPluginVer, setCurrentPluginVer] = useState(null);
  const [currentFile, setCurrentFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [moduleInfo, setModuleInfo] = useState([]);
  const [deleteBtnDisabled, setDeleteBtnDisabled] = useState(true);
  const [tableSelectedRows, setTableSelectedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPageSize, setCurrentPageSize] = useState(20);
  const [open, setOpen] = useState(false);
  const [currentPluginInfo, setCurrentPluginInfo] = useState(false);


  const { search } = useLocation();
  const appId = util.qsParse(search).appId;

  const closeAllModal = useCallback(() => {
    setModalVisible({});
    // 清空错误信息
    setErrorMessage("");
    // 取消队列中的请求
    if (cancelSources.length > 0) {
      // 将全部搜索请求取消
      cancelSources.forEach((cancelSource) => {
        cancelSource.cancel("cancel");
      });
      // 重置
      cancelSources = [];
    }
  }, []);

  const getPluginInfo = useCallback(async (appId) => {
    if (!appId) return;
    try {
      const plugin = await data.getPluginInfoByAppId(appId);
      setPluginInfo(plugin);
    } catch (e) {
      notifier.error(e.message);
    }
  }, []);

  const getPluginVerList = useCallback(
    async (pluginAppId, pageSize, currentPage) => {
      if (!pluginAppId) return;
      const publishFlag = flagFilterItem.value;
      const systemFilter = systemFilterItem.value;
      const publishTimeStart = publishDateStart?.getTime() || "";
      const publishTimeEnd = publishDateEnd?.getTime() || "";
      try {
        const { totalCount, pluginVerList } =
          await data.getPluginVerListByAppId({
            pluginAppId,
            pageSize,
            currentPage,
            keyword,
            publishFlag,
            publishTimeStart,
            publishTimeEnd,
            systemFilter
          });
        setList(pluginVerList);
        setTotal(totalCount);
      } catch (e) {
        notifier.error(e.message);
      }
    },
    [flagFilterItem, keyword, publishDateEnd, publishDateStart,systemFilterItem]
  );

  const handleCurrentPageChange = useCallback(
    (pageNum) => {
      setCurrentPage(pageNum);
      getPluginVerList(appId, tablePageSize, pageNum);
    },
    [appId, getPluginVerList]
  );

  const handleSearch = useCallback(() => {
    if (currentPage === 1) {
      getPluginVerList(appId, tablePageSize, 1);
    } else {
      setCurrentPage(1);
    }
  }, [currentPage, getPluginVerList, appId]);

  const handleFileUpload = useCallback(async (file, onFileUpload) => {
    if (!file) return;
    const cancelSource = http.source();
    cancelSources.push(cancelSource);
    try {
      const { fileId } = await data.uploadFile(
        file,
        cancelSource.token,
        onFileUpload
      );
      // if (fileId) callBack && callBack(true, fileId);
      return [true, fileId, "上传完成"];
    } catch (error) {
      logger.log(error);
      let msg = error.message;
      if (msg === "cancel") {
        msg = "已取消文件上传请求";
      }
      notifier.error(msg);
      return [false, "", error.message];
    }
  }, []);
  // 处理插件版本上传的函数
  const handlePluginVerAdd = useCallback(
    async (form) => {
      try {
        await data.addPluginVer(form);
        // 关闭modal
        closeAllModal();
        // 转到第一页
        getPluginVerList(appId, tablePageSize, 1);
        return true;
      } catch (error) {
        // setErrorMessage(error.message);
        notifier.error(error.message);
      }
    },
    [closeAllModal, getPluginVerList, appId]
  );

  const handlePluginVerUpdate = useCallback(
    async (id, form) => {
      try {
        await data.updatePluginVer(id, form);
        // 关闭modal
        closeAllModal();
        // 刷新当前页
        getPluginVerList(appId, tablePageSize, currentPage);
        return true;
      } catch (error) {
        // setErrorMessage(error.message);
        notifier.error(error.message);
      }
    },
    [closeAllModal, currentPage, getPluginVerList, appId]
  );

  const handlePluginVerDelete = useCallback(async () => {
    try {
      await data.deletePluginVer(currentPluginVer.id);
      // 关闭modal
      closeAllModal();
      // 刷新当前页
      getPluginVerList(appId, tablePageSize, currentPage);
    } catch (error) {
      // setErrorMessage(error.message);
      notifier.error(error.message);
    }
  }, [closeAllModal, currentPage, currentPluginVer, getPluginVerList, appId]);

  const handleFileDelete = useCallback(async () => {
    try {
      await data.deleteFile(currentFile.fileId);
      // 关闭modal
      closeAllModal();
      // 刷新当前页
      getPluginVerList(appId, tablePageSize, currentPage);
    } catch (error) {
      // setErrorMessage(error.message);
      notifier.error(error.message);
    }
  }, [closeAllModal, currentFile, currentPage, getPluginVerList, appId]);

  const reloadCurrentPage = useCallback(async () => {
    // 刷新当前页
    getPluginVerList(appId, tablePageSize, currentPage);
  }, [currentPage, getPluginVerList, appId]);

  const handleFilterSelect = useCallback((item) => {
    logger.log("选择了过滤条件: ", item);
    setFlagFilterItem(item);
  }, []);
  const handleSystemFilterSelect = useCallback((item) => {
    logger.log("选择了过滤条件: ", item);
    setSystemFilterItem(item);
  }, []);

  const resetPublishDate = useCallback(() => {
    setPublishDateStart(null);
    setPublishDateEnd(null);
  }, []);

  // 根据name获取插件信息
  useEffect(() => {
    getPluginInfo(appId);
    getPluginVerList(appId, tablePageSize, 1);
  }, [getPluginInfo, appId, flagFilterItem, publishDateStart, publishDateEnd,systemFilterItem]);


 // 弹窗点击了确认之后的删除逻辑
 const handleMutiPluginVerDelete = async () => {
    let isSelectAll = false
    // 关闭弹窗
    closeAllModal();
    // 开启loading状态
    setLoading(true)
    // 判断本页的内容是否全部删除 如果是全部删除则返回上一页
    if(tableSelectedRows.length === currentPageSize) isSelectAll = true
    if(total % currentPage <= currentPageSize && total - currentPageSize * (currentPage - 1) === tableSelectedRows.length) isSelectAll = true
    for(let i = 0; i < tableSelectedRows.length; i++) {
      await data.deletePluginVer(tableSelectedRows[i].id)
    }
    setLoading(false)
    // 判断 删除之后本页是否为空 不一致返回上一页
    if(isSelectAll) {
      return getPluginVerList(appId,tablePageSize, currentPage - 1 === 0 ? 1 : currentPage - 1);
    }
    getPluginVerList(appId,tablePageSize, currentPage);
  }

  // 删除确认框的变体
  const deleteConfirmModalTypes = {
    pluginVer: {
      content: "确定要删除该插件版本？",
      onConfirm: handlePluginVerDelete,
    },
    file: {
      content: "确定要删除该文件？",
      onConfirm: handleFileDelete,
    },
    mutiPluginVer: {
      content: "确定要删除选中的插件版本？",
      onConfirm: handleMutiPluginVerDelete,
    }
  };


  
  const handleTableSeletion = (selectedRowKeys, selectedRows) => {
    // 在这里存储要删除的插件版本的信息
    setTableSelectedRows(selectedRows)
    if(selectedRows.length === 0) return setDeleteBtnDisabled(true)
    setDeleteBtnDisabled(false)
  }
  // 分页器页码或 pageSize 改变的回调，参数是改变后的页码及每页条数
  const handlePaginationChange = useCallback((page, pageSize) => {
    setCurrentPage(page)
    setCurrentPageSize(pageSize)
    getPluginVerList(appId,pageSize,page)
  },[getPluginVerList])

  const getMoudleInfo = async () => {
    const moduleInfo = await data.getPluginInfoList(50,1)
    setModuleInfo(moduleInfo.pluginList)
  }

  useEffect(() => {
    getMoudleInfo()
  },[]); 

  const onClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    // 弹出确认删除的对话框
    setModalVisible({ confirmModal: true });
    setConfirmModalType("mutiPluginVer");
  }

 

  const history = useHistory();

  // 这里跳转的时候会报错？
  if (!appId) {
    logger.log("未选择插件", search, appId);
    history.push(guide.defaultPath);
    return <></>;
  }

  const tools = [
    {
      type: "update",
      onClick: (data) => {
        setModalType("update");
        setModalVisible({ pluginVerModal: true });
        logger.log("点击了修改 当前点击的插件版本：", data);
        setCurrentPluginVer(data);
      },
    },
    {
      type: "remove",
      onClick: (data) => {
        setModalType("");
        setModalVisible({ confirmModal: true });
        logger.log("点击了删除 当前点击的插件版本：", data);
        setCurrentPluginVer(data);
        setConfirmModalType("pluginVer");
      },
    },
    {
      type: "detail",
      onClick: (data) => {
        // 打开详情的抽屉
        setCurrentPluginInfo(data)
        setOpen(true)
      },
    },
  ]

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      align: 'center',
      key: 'id'
    },
    {
      title: '模块',
      dataIndex: 'pluginAppId',
      align: 'center',
      key: 'pluginAppId',
      render: (pluginAppId) => {
        const module = moduleInfo.find((item) => item.appId === pluginAppId)?.module
        return (
        <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden'}} title={module}>
          {module}
        </div>)
      }
    },
    {
      title: '版本号',
      dataIndex: 'version',
      align: 'center',
      key: 'version',
      render: (version,record) => {
        return (
          <div 
            style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',cursor: 'pointer'}} 
            title={version}
            onClick={() => {
              setCurrentPluginInfo(record)
              setOpen(true)
            }}
          >
            {version}
          </div>)
      }
    },
    {
      title: '发布标志',
      dataIndex: 'publishSystem',
      align: 'center',
      key: 'publishSystem',
      render: (publishSystem, row) => {
        const flag =`${publishSystem} - ${row.publishFlag === 1 ? '正式版' : '测试版'}`
        return (
          <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',width: '120px'}} title={flag}>
            {flag}
          </div>
        )
      },
    },
    {
      title: '编译时间',
      dataIndex: 'buildTime',
      align: 'center',
      key: 'buildTime',
      render: (buildTime) => {
        return (
          <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',width: '138px'}} title={buildTime}>
            {buildTime}
          </div>
        )
      }
    },
    {
      title: '发布时间',
      dataIndex: 'publishTime',
      align: 'center',
      key: 'publishTime',
      render: (time) => {
        const publishTime = moment(time).format('YYYY-MM-DD HH:mm:ss')
        return (
          <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',width: '138px'}} title={publishTime}>
            {publishTime}
          </div>
        )
      }
    },
    {
      title: '描述',
      dataIndex: 'changeInfo',
      align: 'center' ,
      key: 'changeInfo',
      render: (changeInfo) => {
        return (
        <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',width: '200px'}} title={changeInfo}>
          {changeInfo}
        </div>)
      }
    },
    {
      title: 'desc',
      dataIndex: 'changeInfoEn',
      align: 'center' ,
      key: 'changeInfoEn',
      render: (changeInfoEn) => {
        return (
        <div style={{whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden',width: '160px'}} title={changeInfoEn}>
          {changeInfoEn}
        </div>)
      }
    },
    {
      title: '操作',
      align: 'center' ,
      key: 'operate',
      render: (record) => {
        return <ToolGroup auth={!!user} tools={tools} data={record}/>
      }
    },
  ];



  return (
    <StyledPluginVer>
      <StyledMain>
        <Title title={pluginInfo?.module} />
        <StyledSection>
          <Navbar
            barItems={guide.pluginVerBarItems}
            basePath={`/pluginVer`}
            search={search}
            mariginBottom="30px"
          />
          <Switch>
            <Route path={guide.pluginVerPages.detail.basePath}>
              <PluginDetail appId={appId} pluginInfo={pluginInfo} />
            </Route>
            <Route path={guide.pluginVerPages.releases.basePath}>
              <ToolsBar
                auth={!!user}
                tools={[
                  {
                    type: "add",
                    size: "lg",
                    onClick: () => {
                      setModalType("add");
                      setModalVisible({ pluginVerModal: true });
                    },
                  },
                ]}
                search={{
                  value: keyword,
                  setValue: setKeyword,
                  onSearch: handleSearch,
                }}
              />
              <StyledFilterContainer>
                <Filter
                  padding="7px"
                  items={flagFilterItems}
                  itemDesc={flagFilterItem.desc}
                  onSelectItem={handleFilterSelect}
                />
                {/* 增加筛选系统版本 */}
                <Filter
                  padding="7px"
                  items={systemFilterItems}
                  itemDesc={systemFilterItem.desc}
                  onSelectItem={handleSystemFilterSelect}
                  selectName = '系统'
                />
                <StyledDatePickerGroup title="按发布时间筛选">
                  <DatePicker
                    id="1"
                    placeholder="开始日期"
                    date={publishDateStart}
                    setDate={setPublishDateStart}
                  />
                  —
                  <DatePicker
                    id="2"
                    placeholder="结束日期"
                    date={publishDateEnd}
                    setDate={setPublishDateEnd}
                  />
                  <Button
                    onClick={resetPublishDate}
                    marginTop="0"
                    messageArea={false}
                    title="重置日期"
                  >
                    <StyledIcon icon={faUndo} />
                  </Button>
                </StyledDatePickerGroup>
                <BTN onClick={handleDelete} disabled={deleteBtnDisabled} className="historyVerStyle">删除</BTN>
              </StyledFilterContainer>
              {/* <Releases
                auth={!!user}
                list={list}
                module={pluginInfo?.module}
                tools={[
                  {
                    type: "update",
                    onClick: (data) => {
                      setModalType("update");
                      setModalVisible({ pluginVerModal: true });
                      logger.log("点击了修改 当前点击的插件版本：",  );
                      setCurrentPluginVer(data);
                    },
                  },
                  {
                    type: "remove",
                    onClick: (data) => {
                      setModalType("");
                      setModalVisible({ confirmModal: true });
                      logger.log("点击了删除 当前点击的插件版本：", data);
                      setCurrentPluginVer(data);
                      setConfirmModalType("pluginVer");
                    },
                  },
                ]}
                fileTools={[
                  {
                    type: "remove",
                    title: "删除文件",
                    titlePosition: { left: "-70px", top: "0" },
                    onClick: (data) => {
                      setModalType("");
                      setModalVisible({ confirmModal: true });
                      logger.log("点击了删除 当前点击的文件：", data);
                      setCurrentFile(data);
                      setConfirmModalType("file");
                    },
                  },
                ]}
                reload={reloadCurrentPage}
              />
              <PaginationNav
                total={total}
                pageSize={tablePageSize}
                currentPage={currentPage}
                onCurrentPageChange={handleCurrentPageChange}
              /> */}
              <Table 
                rowKey={record => record.id}
                loading={loading}
                dataSource={list} 
                columns={columns}
                rowSelection={{type: 'checkbox',onChange: handleTableSeletion,columnWidth: 30}}
                pagination={{ position: ["bottomCenter"] ,defaultPageSize: 20,pageSizeOptions:['20','50'],showSizeChanger: true,total, onChange: handlePaginationChange}}
              />
              <Drawer title="插件详情" onClose={onClose} visible={open} width={850}>
              <Releases
                auth={!!user}
                list={[currentPluginInfo]}
                module={pluginInfo?.module}
                tools={[
                  {
                    type: "update",
                    onClick: (data) => {
                      setModalType("update");
                      setModalVisible({ pluginVerModal: true });
                      logger.log("点击了修改 当前点击的插件版本：",  );
                      setCurrentPluginVer(data);
                    },
                  },
                  {
                    type: "remove",
                    onClick: (data) => {
                      setModalType("");
                      setModalVisible({ confirmModal: true });
                      logger.log("点击了删除 当前点击的插件版本：", data);
                      setCurrentPluginVer(data);
                      setConfirmModalType("pluginVer");
                    },
                  },
                ]}
                fileTools={[
                  {
                    type: "remove",
                    title: "删除文件",
                    titlePosition: { left: "-70px", top: "0" },
                    onClick: (data) => {
                      setModalType("");
                      setModalVisible({ confirmModal: true });
                      logger.log("点击了删除 当前点击的文件：", data);
                      setCurrentFile(data);
                      setConfirmModalType("file");
                    },
                  },
                ]}
                reload={reloadCurrentPage}
              />
              </Drawer>
              <PluginVerModal
                module={pluginInfo?.module}
                errorMessage={errorMessage}
                pluginAppId={appId}
                visible={modalVisible.pluginVerModal}
                type={modalType}
                displayTargetPlugin
                data={currentPluginVer}
                onClose={closeAllModal}
                onFileUpload={handleFileUpload}
                onPluginVerAdd={handlePluginVerAdd}
                onPluginVerUpdate={handlePluginVerUpdate}
              />
              <ConfirmModal
                errorMessage={errorMessage}
                visible={modalVisible.confirmModal}
                onClose={closeAllModal}
                title="提示"
                content={deleteConfirmModalTypes[confirmModalType]?.content}
                confirmLabel="删除"
                cancelLabel="取消"
                confirmType="danger"
                onConfirm={deleteConfirmModalTypes[confirmModalType]?.onConfirm}
                onCancel={closeAllModal}
              />
            </Route>
            {/* <Redirect exact from={guide.pluginVerBasePath} to={guide.defaultPluginVerPath} /> */}
          </Switch>
        </StyledSection>
      </StyledMain>
    </StyledPluginVer>
  );
};

export default PluginVer;
